import { Routes } from '@angular/router';
import { authGuard } from '../../guards/auth.guard';
import { ContentLayoutComponent } from '../../shared/layout-components/layout/content-layout/content-layout.component';

export const routes: Routes = [
  {
    path: '',
    component: ContentLayoutComponent,
    children: [
      {
        path: '',
        loadComponent: () => import('./sports.component').then((m) => m.SportsComponent),
      },
      {
        path: 'element/:elementId',
        canActivate: [authGuard],
        loadComponent: () => import('./sport-element-list/sport-element-list.component').then((m) => m.SportElementListComponent),
        data: {
          renderMode: 'default', // Route will be rendered dynamically at runtime
          breadcrumb: 'Detail',
        },
      },
      {
        path: ':elementId/:sportId',
        canActivate: [authGuard],
        loadComponent: () => import('./sports-detail/sports-detail.component').then((m) => m.SportsDetailComponent),
        data: {
          renderMode: 'default', // Route will be rendered dynamically at runtime
          breadcrumb: 'Detail',
        },
      },
      {
        path: ':sportId',
        canActivate: [authGuard],
        loadComponent: () => import('./sports-detail/sports-detail.component').then((m) => m.SportsDetailComponent),
        data: {
          renderMode: 'default', // Route will be rendered dynamically at runtime
          breadcrumb: 'Detail',
        },
      },
      {
        path: '', // Blank route
        redirectTo: '',
        pathMatch: 'full',
      },
      {
        path: '**', // Wildcard route
        redirectTo: '',
        pathMatch: 'full',
      },
    ],
  },
];
